import { GroupingCacheKeysEnum } from '@/enums/GroupingCacheKeysEnum'
import { useApiMutation } from './useApiMutation'

import type { MutationFunction } from '@tanstack/react-query'

interface Props<TData = unknown, TError = unknown, TVariables = void, TContext = unknown> {
  /** Mutation function */
  func: MutationFunction<TData, TVariables>
  /** Translation key base for the snackbar message. */
  translationKeyBase?: string
  invalidateQueries?: boolean
  onSuccess?: (data: TData, variables: TVariables, context: TContext | undefined) => Promise<unknown> | void
  onError?: (error: TError, variables: TVariables, context: TContext | undefined) => Promise<unknown> | void
  onSettled?: (
    data: TData | undefined,
    error: TError | null,
    variables: TVariables,
    context: TContext | undefined
  ) => Promise<unknown> | void
}

export const useCartApiMutation = <TData = unknown, TError = unknown, TVariables = void, TContext = unknown>({
  func,
  translationKeyBase,
  invalidateQueries,
  onSettled,
  onSuccess,
  onError,
}: Props<TData, TError, TVariables, TContext>) => {
  return useApiMutation({
    func,
    translationKeyBase,
    invalidateQueries,
    cacheKey: [GroupingCacheKeysEnum.Cart],
    onSettled,
    onSuccess,
    onError,
  })
}
